import { RopType } from "../../engine/poly/registers/nodes/types/Rop";
import { CoreObject } from "../geometry/Object";
import { CameraAttribute } from "./CoreCamera";
import { CoreType } from "../Type";
export class CoreCameraCSSRendererController {
  static isCSSRendererNode(node) {
    return node.type() == RopType.CSS2D || node.type() == RopType.CSS3D;
  }
  static cssRendererConfig(options) {
    const { canvas, scene, camera } = options;
    let cssRendererNode;
    const postProcessNodePath = CoreObject.attribValue(camera, CameraAttribute.CSS_RENDERER_PATH);
    if (postProcessNodePath && CoreType.isString(postProcessNodePath)) {
      const foundNode = scene.node(postProcessNodePath);
      if (foundNode && this.isCSSRendererNode(foundNode)) {
        cssRendererNode = foundNode;
      }
    }
    if (!cssRendererNode) {
      return;
    }
    const cssRenderer = cssRendererNode.renderer(canvas);
    return { cssRenderer, cssRendererNode };
  }
}
